import {Injectable} from '@angular/core';
import {BehaviorSubject,  Observable} from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { AuthService } from '../../../shared/services/auth.service';


@Injectable()
export class sideNavService {
  private readonly urlBase = '/api/';
  private readonly urlMail = '/mail/';

  constructor (private httpClient: HttpClient) {}

  unlock(up:any): Observable<any> {
    return this.httpClient.post<any>(this.urlBase + 'SideNavUnlock',up);
  }

}